module.exports = __webpack_public_path__ + "static/media/mobile-app.0d970e15.png";